<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-2">
        <label>Número da Solicitação</label>
        <input
          type="text"
          class="form-control"
          v-model="filters.numero_solicitacao"
        />
      </div>
      <div class="col-md-2">
        <label>Data da Solicitação</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_solicitacao"
        />
      </div>
      <div class="col-md-2">
        <label>Data do Transporte</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_procedimento"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button class="btn btn-primary" @click="getSolitacoes">Filtrar</button>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="limparFiltros">
          Limpar filtros
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button
          class="btn btn-export-j4 float-left btn-sm"
          data-toggle="modal"
          data-target="#modalExport"
        >
          Exportar em Excel
        </button>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalExport"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalExportTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Exportar</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-content modal-lg mt-1">
            <div
              class="alert alert-warning"
              role="alert"
              v-if="!filters.data_inicio && !filters.data_fim"
            >
              Para exportar todos os registros, basta não definir nenhum
              intervalo de datas e proceder com a exportação.
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>

            <div class="d-flex justify-content-between">
              <div class="col-md-6 mb-1">
                <label>Data de Ínicio</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filters.data_inicio"
                />
              </div>
              <div class="col-md-6 mb-1">
                <label>Data do Fim</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filters.data_fim"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="exportToExcel"
            >
              Exportar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="ibox">
            <div class="ibox-title" style="padding: 16px">
              <h3>Solicitações</h3>
            </div>
            <div class="ibox-content">
              <div class="table-responsive" style="padding: 10px">
                <table
                  class="VueTables__table table table-striped table-bordered table-hover"
                  style="padding: 10px"
                >
                  <thead>
                    <tr>
                      <th scope="col">NÚMERO SOLICITACAO</th>
                      <th scope="col">DATA DA SOLICITAÇÃO</th>
                      <th scope="col">DATA DO TRANSPORTE</th>
                      <th scope="col">TIPO DO TRANSPORTE</th>
                      <th scope="col">MOTIVO DO TRANSPORTE</th>
                      <th scope="col">VIATURA</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">CLASSIFICAÇÃO</th>
                      <th scope="col">AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="solicitacao in solicitacoes"
                      :key="solicitacao.numero_solicitacao"
                    >
                      <td>{{ solicitacao.numero_solicitacao }}</td>
                      <td>{{ solicitacao.data_solicitacao_f }}</td>
                      <td>{{ solicitacao.data_procedimento_f }}</td>
                      <td>
                        {{ solicitacao.tipo_transporte.tipo_transporte_nome }}
                      </td>
                      <td>
                        {{
                          solicitacao.motivo_transporte.motivo_transporte_nome
                        }}
                      </td>
                      <td>
                        {{
                          solicitacao.veiculo
                            ? solicitacao.veiculo.veiculo.nome_veiculo
                            : "Sem viatura empenhada"
                        }}
                      </td>
                      <td v-html="status_solicitacao(solicitacao)"></td>
                      <td v-html="classificacaoBadge(solicitacao)"></td>
                      <td>
                        <router-link
                          :to="'/programacoes/programacao/' + solicitacao.id"
                          title="Visualizar"
                          class="btn btn-crud view"
                          target="_blank"
                        >
                          <i class="fas fa-eye"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
                >
                  <pagination
                    :records="total"
                    :options="options"
                    :per-page="15"
                    @paginate="getSolitacoes"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";

export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      autoRefreshAtivado: false,
      pages: [],
      solicitacoes: [],
      showFinished: false,
      filters: {
        numero_solicitacao: "",
        data_procedimento: "",
        data_solicitacao: "",
      },
    };
  },
  components: {
    BaseCrud,
    vSelect,
    Pagination,
  },

  methods: {
    exportToExcel() {
      const self = this;
      const dataInicio = self.filters.data_inicio;
      const dataFim = self.filters.data_fim;

      if (dataInicio || dataFim) {
        if (dataInicio && dataFim) {
          var url = `${self.$store.state.url}rih_sem_vinculo/exportar?data_inicio=${dataInicio}&data_fim=${dataFim} 23:59:59`;
          window.open(url, "_blank").focus();
        } else {
          self.$message(
            null,
            "Por favor, preencha ambos os campos de data.",
            "error"
          );
          return;
        }
      } else {
        var url = `${self.$store.state.url}rihs-sem-vinculo/exportar`;
        window.open(url, "_blank").focus();
      }
    },
    status_solicitacao: function (row) {
      if (row.status_solicitacao == 0) {
        return "<h5><span class='badge badge-warning'>Solicitado</span></h5>";
      }
      if (row.status_solicitacao == 1) {
        return "<h5><span class='badge badge-info'>Aguardando</span></h5>";
      }
      if (row.status_solicitacao == 2) {
        return "<h5><span class='badge badge-primary'>Despachado</span></h5>";
      }
      if (row.status_solicitacao == 3) {
        return "<h5><span class='badge badge-success'>Finalizado</span></h5>";
      }
      if (row.status_solicitacao == 4) {
        return "<h5><span class='badge badge-danger'>Cancelado</span></h5>";
      }
    },
    classificacaoBadge: function (row) {
      if (row.flag_mandado_judicial == 1) {
        return "<h5><span class='badge' style='background: #550033;'>Mandado judicial</span></h5>";
      }
      if (!row.classificacao) {
        return "<h5><span class='badge badge-secondary'>Vaga zero</span></h5>";
      }
      if (row.classificacao_id == 6) {
        return "<h5><span class='badge badge-danger'>Vermelho</span></h5>";
      }
      if (row.classificacao_id == 7) {
        return "<h5><span class='badge badge-primary'>Azul</span></h5>";
      }
      if (row.classificacao_id == 9) {
        return "<h5><span class='badge' style='background: #ffc107; color: #fff;'>Amarelo</span></h5>";
      }
    },
    getSolitacoes(page) {
      const self = this;

      self.page = page || 1;

      let api =
        self.$store.state.api +
        "solicitacoes/sem_vinculo_rihs?page=" +
        self.page;

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.solicitacoes = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    limparFiltros() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.getSolitacoes();
    },
  },
  mounted() {
    const savedFilters = JSON.parse(localStorage.getItem("savedFilters"));
    if (savedFilters) {
      this.filters = savedFilters;
    }

    this.getSolitacoes();
  },
  watch: {
    filters: {
      handler(newFilters) {
        localStorage.setItem("savedFilters", JSON.stringify(newFilters));
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>